// Scheduled vacation banner logic (shared by public pages + admin preview).
// Phases based on the current date:
//   - too early (> 3 weeks before start)  -> no banner
//   - within 3 weeks before start          -> "upcoming" advance-notice banner
//   - between start and return date        -> "active" on-holiday banner
//   - after return date                    -> no banner (auto-off)
// If no start date is set, an armed banner behaves like the legacy immediate mode
// (shows the on-holiday banner until the return date, then auto-off).

const ADVANCE_DAYS = 21;

function parseLocalDate(str) {
  if (!str) return null;
  const datePart = String(str).slice(0, 10);
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d, 0, 0, 0, 0);
}

export function formatVacationDate(str) {
  const d = parseLocalDate(str);
  if (!d) return '';
  return d.toLocaleDateString('en-IE', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
}

export function getVacationBanner(settings) {
  if (!settings?.vacation_mode_active) return null;

  const now = new Date();
  const start = parseLocalDate(settings.vacation_mode_start_date);
  const end = parseLocalDate(settings.vacation_mode_return_date);
  const endInclusive = end
    ? new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 999)
    : null;

  // Holiday finished -> banner switches off automatically.
  if (endInclusive && now > endInclusive) return null;

  if (start) {
    const advanceStart = new Date(start.getFullYear(), start.getMonth(), start.getDate() - ADVANCE_DAYS, 0, 0, 0, 0);
    if (now < advanceStart) return null; // more than 3 weeks out — nothing yet
    if (now < start) {
      return {
        phase: 'upcoming',
        message: settings.vacation_mode_upcoming_message || '',
        startDate: settings.vacation_mode_start_date || '',
        endDate: settings.vacation_mode_return_date || '',
      };
    }
  }

  // No start date (legacy immediate) OR we are inside the holiday window.
  return {
    phase: 'active',
    message: settings.vacation_mode_message || '',
    startDate: settings.vacation_mode_start_date || '',
    endDate: settings.vacation_mode_return_date || '',
  };
}
